module.exports = __webpack_public_path__ + "static/media/session7.5f207e4a.svg";